<div
    class="flex flex-row justify-between theme-color text-sm font-medium mr-5 items-center">

    <ng-container *ngFor="let action of commands; index as i ">

        <span *ngIf="action.layout === 'normal'"
            class="text-sm theme-color mr-2 flex items-center gap-1">
            <mat-icon *ngIf="action.icon" class="material-icons-outlined"
                style="font-size:16px;width:16px;height:16px;line-height:16px">{{action.icon}}</mat-icon>
            {{((action.label || '') | translate) | async}}
        </span>

        <button *ngIf="!action.layout" mat-button color="{{action.type}}"
            [disabled]="isLoading(i) || isDisabled(i)"
            (click)="onClick(i)"
            class="flex flex-row justify-between items-center ml-2 uppercase">
            <span class="sm:inline-block hidden">
                {{((action.label || '') | translate) | async}}
            </span>
            <mat-icon *ngIf="action.icon && !isLoading(i)"
                class="material-icons-outlined ml-2">
                {{action.icon}}
            </mat-icon>
            <mat-spinner *ngIf="isLoading(i)" diameter="20"
                class="inline-block ml-4">
            </mat-spinner>
        </button>

        <button *ngIf="action.layout === 'flat'" mat-flat-button
            color="{{action.type}}" (click)="onClick(i)"
            [disabled]="isLoading(i) || isDisabled(i)"
            class="flex flex-row justify-between items-center uppercase ">
            {{((action.label || '') | translate) | async}}
            <mat-icon *ngIf="action.icon && !isLoading(i)"
                class="material-icons-outlined ml-2">
                {{action.icon}}
            </mat-icon>
            <mat-spinner *ngIf="isLoading(i)" diameter="20"
                class="inline-block ml-4">
            </mat-spinner>
        </button>

        <button *ngIf="action.layout === 'raised'" mat-flat-button
            color="{{action.type}}" (click)="onClick(i)"
            [disabled]="isLoading(i) || isDisabled(i)"
            class="flex flex-row justify-between items-center uppercase">
            {{((action.label || '') | translate) | async}}
            <mat-icon *ngIf="action.icon && !isLoading(i)"
                class="material-icons-outlined ml-2">
                {{action.icon}}
            </mat-icon>
            <mat-spinner *ngIf="isLoading(i)" diameter="20"
                class="inline-block ml-4">
            </mat-spinner>
        </button>
    </ng-container>
</div>